import React from 'react';
import { IconSearch } from './entIcons';

export default function EntToolbar({
  search,
  searchPlaceholder = 'Search',
  onSearch,
  searchLabel = 'Search',
  children,
  actions,
}) {
  return (
    <div className="ent-toolbar">
      {onSearch ? (
        <label className="ent-search">
          <span className="ent-search-icon" aria-hidden="true">
            <IconSearch size={16} />
          </span>
          <span className="ent-sr-only">{searchLabel}</span>
          <input
            type="search"
            value={search}
            onChange={(event) => onSearch(event.target.value)}
            placeholder={searchPlaceholder}
            autoComplete="off"
          />
        </label>
      ) : null}
      {children ? <div className="ent-toolbar-filters">{children}</div> : null}
      {actions ? <div className="ent-toolbar-actions">{actions}</div> : null}
    </div>
  );
}
